import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Miniatura da foto de comprovação do checklist, que expande num lightbox ao clicar.
 * O endpoint é autenticado, então baixa a imagem via axios (com o token) como blob
 * e usa um object URL no <img> — não abre em nova aba.
 *
 * Props:
 *   - url: endpoint da foto (ex: `${API}/checklist/tarefas/12/filial/1/foto`)
 *   - tamanho: px da miniatura (default 56)
 */
export default function FotoChecklist({ url, tamanho = 56 }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [erro, setErro] = useState(false);
  const [ampliado, setAmpliado] = useState(false);

  useEffect(() => {
    let objeto = null;
    let vivo = true;
    setErro(false);
    setBlobUrl(null);
    axios.get(url, { responseType: 'blob' })
      .then(r => { if (!vivo) return; objeto = URL.createObjectURL(r.data); setBlobUrl(objeto); })
      .catch(() => { if (vivo) setErro(true); });
    return () => { vivo = false; if (objeto) URL.revokeObjectURL(objeto); };
  }, [url]);

  if (erro) return null;
  if (!blobUrl) return <div style={{ width: tamanho, height: tamanho, borderRadius: 8, background: '#f0f0f0', flexShrink: 0 }} />;

  return (
    <>
      <img
        src={blobUrl}
        alt="Foto da tarefa"
        onClick={(e) => { e.stopPropagation(); setAmpliado(true); }}
        style={{ width: tamanho, height: tamanho, objectFit: 'cover', borderRadius: 8, border: '1px solid #eee', cursor: 'zoom-in', flexShrink: 0 }}
      />
      {ampliado && (
        <div
          onClick={(e) => { e.stopPropagation(); setAmpliado(false); }}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out', padding: 24 }}
          role="dialog" aria-label="Foto ampliada"
        >
          <img src={blobUrl} alt="Foto ampliada" style={{ maxWidth: '95vw', maxHeight: '90vh', borderRadius: 12, boxShadow: '0 12px 40px rgba(0,0,0,0.5)', objectFit: 'contain' }} onClick={(e) => e.stopPropagation()} />
          <button
            onClick={(e) => { e.stopPropagation(); setAmpliado(false); }}
            aria-label="Fechar"
            style={{ position: 'absolute', top: 20, right: 24, background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', borderRadius: '50%', width: 44, height: 44, fontSize: '1.4rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      )}
    </>
  );
}
